import React from 'react';

const Form = ({ children, ...props }) => {
  return (
    <form sx={{ 
      mt: 1
    }} noValidate {...props}>
      {children}
    </form>
  );
};

export default Form;
